<!-- 主页面 -->
<template>
  <!-- 背景大图 -->
  <div class="dataBoard-bgimg" style="box-shadow: 0px 0px 30px #36b8bf inset">
    <div class="top-box">
      <!-- 地图 -->
      <div class="bm-view">
        <div id="container"></div>
      </div>
      <el-row :gutter="20" type="flex" justify="space-around">
        <el-col :span="6">
          <!-- 左边区域 -->
          <div class="dataBoard-left-box">
            <!-- 卡片框 -->
            <div class="bottom-bigbox">
              <!-- 左边单位卡片区域 -->
              <div class="leftBox">
                <!-- 单位树 -->
                <el-tree
                  class="treeBox"
                  :data="depTrees"
                  :props="defaultTreesProps"
                  default-expand-all
                  :expand-on-click-node="false"
                  :highlight-current="true"
                  @node-click="handleNodeClick"
                >
                </el-tree>
              </div>
            </div>
          </div>
        </el-col>

        <!-- 中间区域 -->
        <el-col :span="11">
          <div class="dataBoard-center-box">
            <div class="Hometitlebox" style="text-align: center; ">
              <a
                style="color: #00e4ff;font-size: 2.5rem;font-weight: 900;font-family:'STXihei';"
                >智能数据一体化看板</a
              >
            </div>
          </div>
          <!-- <div class="dataBoard-center-box">
          <div class="center-box">
            <div class="map-data" id="myEcharts" ref="myEcharts"></div>
          </div>
        </div> -->
        </el-col>
        <!-- 右边区域 -->
        <el-col :span="6">
          <div class="dataBoard-right-box">
            <!-- 右边上面区域 -->
            <div class="right-top-box">
              <div class="backround">
                <div class="toptitle">
                  <div class="item">日期</div>
                  <div class="item">事件</div>
                </div>
                <vue-seamless-scroll
                  :data="alarmList"
                  :class-option="optionHover"
                  class="seamless-warp"
                >
                  <el-table :data="alarmList" border :show-header="status">
                    <el-table-column prop="alarmCreateTime" label="日期">
                    </el-table-column>
                    <el-table-column prop="alarmContent" label="事件">
                      <template v-slot="alarmContentSlot">
                        <span v-if="alarmContentSlot.row.alarmType == 1"
                          >发现目标车牌:{{
                            alarmContentSlot.row.alarmContent.match(
                              /"numberplateTxt":"([^"]+)"/
                            )[1]
                          }}</span
                        >
                        <span v-if="alarmContentSlot.row.alarmType == 2">
                          发现目标人员:{{
                            alarmContentSlot.row.alarmContent.match(
                              /"faceName":"([^"]+)"/
                            )[1]
                          }}</span
                        >
                        <span v-if="alarmContentSlot.row.alarmType == 3">
                          超出电子围栏</span
                        >
                        <span v-if="alarmContentSlot.row.alarmType == 4">
                          sos求救</span
                        >
                        <span v-if="alarmContentSlot.row.alarmType == 5">
                          位置监听异常</span
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                </vue-seamless-scroll>
              </div>
            </div>
            <!-- 右边中间区域 -->
            <div class="right-center-box">
              <div class="DataRanking" id="DataRanking" ref="DataRanking"></div>
            </div>
            <!-- 右边下面区域 -->
            <div class="left-top-box">
              <div class="num">
                <div class="lx">
                  <div class=" lx-txt">{{ device.total }}</div>
                </div>
                <div class="zx">
                  <div class="zx-txt">{{ device.onlineCount }}</div>
                </div>
                <div class="wzc">
                  <div class="wzc-txt">{{ device.offlineCount }}</div>
                </div>
              </div>
              <div class="txt">
                <div class="lx-txt">全部设备</div>
                <div class="zx-txt">在线设备</div>
                <div class="wzc-txt">离线设备</div>
              </div>
            </div>
          </div></el-col
        >
      </el-row>
    </div>
  </div>
</template>

<script>
// 引入百度地图样式
import custom_map_config from "../../../assets/css/custom_map_config4.json";

// 引入echarts图标
import * as echarts from "echarts";
// import { EventBus } from '../../../utils/eventBus';
export default {
  data() {
    return {
      //设备在线信息
      device: {
        total: "",
        onlineCount: "",
        offlineCount: ""
      },
      alarmList: [], //报警信息
      MediaDurationList: [], //人员拍摄视频时长前七位数据
      depTrees: [], // 单位树信息
      defaultTreesProps: {
        children: "depChilds",
        label: "depName"
      },
      // 全部单位人员设备树
      ArchInfo: [],
      // 在线单位人员设备树
      onlineArchInfo: [],
      // 在线设备信息
      onlineDevice: [],
      // 默认地图中心点经度
      mapCenterLng: "113.75842",
      // 默认地图中心点纬度
      mapCenterLat: "23.027308",
      // 默认地图缩放级别
      mapZoom: 5,
      setInt: null,
      setTimeDepPersonDevTree: null, //定时获取单位人员设备树
      setIntMarker: null, //定时更新坐标标签，
      timerId: null, //获取getDevice方法定时器
      status: false
    };
  },
  mounted() {
    this.getDevice(); //获取设备信息
    // 设置定时器，每分钟执行一次 getDevice 方法
    this.timerId = setInterval(() => {
      this.getDevice();
    }, 30000); // 每分钟 30000 毫秒
    this.GetAllDepTrees(); //获取单位树
    this.initMap(); // 显示地图
    // 获取组织架构信息
    this.getDepPersonDevTree();
    // this.DataRanking();
    // this.flashit();
  },
  computed: {
    // 实时滚动模块  vue-seamless-scroll
    optionHover() {
      return {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      };
    }
  },
  //离开页面清除定时器
  beforeRouteLeave(to, from, next) {
    clearTimeout(this.setTimeDepPersonDevTree);
    clearInterval(this.setInt);
    clearInterval(this.setIntMarker);
    next();
  },
  beforeDestroy() {
    // 在组件销毁前清除定时器
    if (this.timerId) {
      clearInterval(this.timerId);
    }
  },
  methods: {
    //  获取组织架构信息
    async getDepPersonDevTree() {
      const { data: res } = await this.$axios.get(
        `${this.$api}/getDepPersonDevTree`
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.ArchInfo = res.data;

      // 设置5秒发送请求一次获取组织架构信息
      this.setTimeDepPersonDevTree = setTimeout(() => {
        this.getDepPersonDevTree();
      }, 5000);
    },
    // 调用百度地图
    initMap() {
      setTimeout(() => {
        // 创建地图实例
        this.BMapGL = BMapGL; //把百度地图库引入到this
        this.map = new BMapGL.Map("container", {
          showVectorStreetLayer: true // 设置是否加载POI
          // showVectorLine: true, //设置是否加载路网数据，注意:路网数
        }); //container为dom元素id，创建Map实例
        //设置map显示类型
        //BMAP_SATELLITE_MAP 地图卫星模式
        //BMAP_NORMAL_MAP 普通模式
        this.map.setMapType(BMAP_NORMAL_MAP);
        // this.map.setMapType(BMAP_SATELLITE_MAP);
        //地图个性化样式
        this.map.setMapStyleV2({
          // styleId: "a0c43e8c7279db0a4a032712d0e4c32c", //官网地图api个性化获取
          // styleJson:[{}] //也可以json方式个性化
          styleJson: custom_map_config
          // styleJson: stylejson,
        });

        var zoomCtrl = new BMapGL.ZoomControl({
          // 控件的停靠位置
          anchor: BMAP_ANCHOR_TOP_RIGHT,
          // 控件基于停靠位置的偏移量（可选）
          offset: new BMapGL.Size(10, 5)
        }); // 添加缩放控件
        // this.map.addControl(zoomCtrl);

        // 设置地图允许的最小级别。
        this.map.setMinZoom(5);

        var navi3DCtrl = new BMapGL.NavigationControl3D({
          anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
          // 控件基于停靠位置的偏移量（可选）
          offset: new BMapGL.Size(5, 10)
        }); // 添加3D控件
        // this.map.addControl(navi3DCtrl);
        //开启鼠标滚轮缩放
        this.map.enableScrollWheelZoom(true);

        setTimeout(() => {
          //  解决： Bug 百度地图centerAndZoom设置中心点后，中心点偏移
          //  原因：因为容器在隐藏和显示之间切换时，容器还没创建好，宽高为0，这时设置中心点就会是在左上角
          //  方法： 定时器setTimeout，延时设置中心点
          // 初始化地图,设置中心点坐标和地图级
          this.map.centerAndZoom(
            new BMapGL.Point(this.mapCenterLng, this.mapCenterLat),
            this.mapZoom
          );

          // 添加地图类型控件
          // this.map.addControl(
          //   new BMapGL.MapTypeControl({
          //     // 控件的停靠位置（可选，默认左上角）
          //     anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
          //     // 控件基于停靠位置的偏移量（可选）
          //     offset: new BMapGL.Size(8, 70),
          //     mapTypes: [BMAP_NORMAL_MAP, BMAP_SATELLITE_MAP],
          //   })
          // );

          // 创建城市选择控件
          // var cityControl = new BMapGL.CityListControl({
          //   // 控件的停靠位置（可选，默认左上角）
          //   anchor: BMAP_ANCHOR_TOP_RIGHT,
          //   // 控件基于停靠位置的偏移量（可选）
          //   offset: new BMapGL.Size(50, 5)
          // });
          // 将控件添加到地图上
          // this.map.addControl(cityControl);
        }, 1000);

        // 初始化地图，设置中心点坐标和地图级别
        // this.map.centerAndZoom(new BMapGL.Point(this.lng, this.lat), 5);

        //地图旋转角度
        // this.map.setHeading(10);

        //地图倾斜角度
        // this.map.setTilt(19);

        //修改地图中心点
        // this.map.setCenter(this.lng, this.lat);

        this.onlineDevice = [];
        // 清除标记物
        this.map.clearOverlays();
        // 获取在线设备信息
        this.levelOrderTraverse();

        // 创建执法仪图标
        var zfy_online = new BMapGL.Icon(
          "../static/images/map/zfy.png",
          new BMapGL.Size(50, 50)
        );
        // 创建安全帽图标
        var aqm_online = new BMapGL.Icon(
          "../static/images/map/aqm.png",
          new BMapGL.Size(50, 50)
        );
        // 创建布控球图标
        var aqm_online = new BMapGL.Icon(
          "../static/images/map/bkq.png",
          new BMapGL.Size(50, 50)
        );
        // 创建无人机图标
        var wrj_online = new BMapGL.Icon(
          "../static/images/map/wrj.png",
          new BMapGL.Size(50, 50)
        );
        // 创建摄像机
        var jksxj_online = new BMapGL.Icon(
          "../static/images/map/sxj.png",
          new BMapGL.Size(50, 50)
        );
        // 智能广播
        var zngb_online = new BMapGL.Icon(
          "../static/images/map/zngb.png",
          new BMapGL.Size(50, 50)
        );
        // 得到每台在线设备的信息
        for (let i = 0; i < this.onlineDevice.length; i++) {
          const element = this.onlineDevice[i];
          var lng = this.onlineDevice[i].status.lng;
          var lat = this.onlineDevice[i].status.lat;
          var name = this.onlineDevice[i].username;
          var devideType = this.onlineDevice[i].devideType;
          // console.log(lng, lat, name, devideType);

          // 创建Marker标注
          if (lng && lat) {
            if (lng[i] !== "0.0" && lat[i] !== "0.0") {
              // 转换后的才行设备经纬度
              var point = this.wgs84ToBd09(lng, lat);
              // console.log("point", point);
              var lng = point[0];
              var lat = point[1];
              let marker1 = new BMapGL.Marker(new BMapGL.Point(lng, lat), {
                icon:
                  devideType == 1
                    ? zfy_online
                    : devideType == 2
                    ? aqm_online
                    : devideType == 3
                    ? aqm_online
                    : devideType == 4
                    ? wrj_online
                    : devideType == 5
                    ? jksxj_online
                    : zngb_online,
                offset: new BMapGL.Size(0, -15)
              });
              this.map.addOverlay(marker1); //添加坐标

              var opts = {
                position: new BMapGL.Point(lng, lat), // 指定文本标注所在的地理位置
                offset: new BMapGL.Size(18, -40) // 设置文本偏移量
              };
              // 创建文本标注对象
              var label = new BMapGL.Label(name, opts);
              // 自定义文本标注样式
              label.setStyle({
                color: "#076961",
                borderRadius: "5px",
                borderColor: "#ccc",
                fontWeight: 700,
                fontSize: "15px",
                height: "14px",
                padding: "2px",
                lineHeight: "14px",
                fontFamily: "微软雅黑"
              });

              this.map.addOverlay(label); //添加文本备注
            }
          }
        }
        this.setIntMarker = setInterval(() => {
          this.Marker();
        }, 30000);
      }, 400);
    },

    //更新图标
    Marker() {
      // 清除标记物
      this.map.clearOverlays();
      this.onlineDevice = [];
      // 获取在线设备信息
      this.levelOrderTraverse();
      // 创建执法仪图标
      var zfy_online = new BMapGL.Icon(
        "../static/images/map/zfy.png",
        new BMapGL.Size(50, 50)
      );
      // 创建安全帽图标
      var aqm_online = new BMapGL.Icon(
        "../static/images/map/aqm.png",
        new BMapGL.Size(50, 50)
      );
      // 创建布控球图标
      var aqm_online = new BMapGL.Icon(
        "../static/images/map/bkq.png",
        new BMapGL.Size(50, 50)
      );
      // 创建无人机图标
      var wrj_online = new BMapGL.Icon(
        "../static/images/map/wrj.png",
        new BMapGL.Size(50, 50)
      );

      // 创建摄像机
      var jksxj_online = new BMapGL.Icon(
        "../static/images/map/sxj.png",
        new BMapGL.Size(50, 50)
      );
      // 智能广播
      var zngb_online = new BMapGL.Icon(
        "../static/images/map/zngb.png",
        new BMapGL.Size(50, 50)
      );

      // 得到每台在线设备的信息
      for (let i = 0; i < this.onlineDevice.length; i++) {
        const element = this.onlineDevice[i];
        var lng = this.onlineDevice[i].status.lng;
        var lat = this.onlineDevice[i].status.lat;
        var name = this.onlineDevice[i].username;
        var devideType = this.onlineDevice[i].devideType;
        // console.log(lng, lat, name, devideType);
        // 创建Marker标注
        if (lng && lat) {
          if (lng[i] !== "0.0" && lat[i] !== "0.0") {
            // 转换后的才行设备经纬度
            var point = this.wgs84ToBd09(lng, lat);
            // console.log("point", point);
            var lng = point[0];
            var lat = point[1];

            let marker1 = new BMapGL.Marker(new BMapGL.Point(lng, lat), {
              icon:
                devideType == 1
                  ? zfy_online
                  : devideType == 2
                  ? aqm_online
                  : devideType == 3
                  ? aqm_online
                  : devideType == 4
                  ? wrj_online
                  : devideType == 5
                  ? jksxj_online
                  : zngb_online,
              offset: new BMapGL.Size(0, -15)
            });
            this.map.addOverlay(marker1); //添加坐标

            var opts = {
              position: new BMapGL.Point(lng, lat), // 指定文本标注所在的地理位置
              offset: new BMapGL.Size(18, -40) // 设置文本偏移量
            };
            // 创建文本标注对象
            var label = new BMapGL.Label(name, opts);
            // 自定义文本标注样式
            label.setStyle({
              color: "#076961",
              borderRadius: "5px",
              borderColor: "#ccc",
              fontWeight: 700,
              fontSize: "15px",
              height: "14px",
              padding: "2px",
              lineHeight: "14px",
              fontFamily: "微软雅黑"
            });

            this.map.addOverlay(label); //添加文本备注
          }
        }
      }
    },

    // 将wgs84转换成Bd09坐标系
    wgs84ToBd09(lng, lat) {
      var PI = (3.14159265358979324 * 3000.0) / 180.0;
      var x = parseFloat(lng),
        y = parseFloat(lat);
      var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * PI);
      var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * PI);
      // var bdLng = z * Math.cos(theta) + 0.0065;
      // var bdLat = z * Math.sin(theta) + 0.006;
      var bdLng = z * Math.cos(theta) + 0.0116;
      var bdLat = z * Math.sin(theta) + 0.0032;
      return [bdLng, bdLat];
    },

    // 在线设备信息
    levelOrderTraverse() {
      const levelNodes = [...this.ArchInfo];
      while (levelNodes.length) {
        const temp = [],
          count = levelNodes.length;
        for (let i = 0; i < count; i++) {
          const node = levelNodes.shift();
          if (node.type === 2) {
            // 如果 type 为 2，将 name 添加到type=2的 username 中
            if (node.name) {
              for (let j = 0; j < node.children.length; j++) {
                node.children[j].username = node.name;
              }
            }
          }
          if (node.type === 3 && node.status.online === true) {
            // 如果 type 为 3，并且 status 的 online 为 true，添加到 temp 中
            temp.push(node);
          }

          if (node.children) levelNodes.push(...node.children);
        }
        this.onlineDevice.push(...temp);
      }
      return this.onlineDevice;
    },
    // 人员数据排行榜
    DataRanking() {
      // 获取当前的 MediaDurationList 并按 mediaDuration 值从大到小排序
      const sortedList = [...this.MediaDurationList].sort(
        (a, b) => a.mediaDuration - b.mediaDuration
      );

      // 提取排序后的 empName 和 mediaDuration 值
      let ydata = sortedList.map(employee => employee.empName);
      let xdata = sortedList.map(employee => employee.mediaDuration);
      var DataRanking = echarts.init(this.$refs.DataRanking);

      var option;
      option = {
        title: {
          text: "本月排行榜",
          left: "center",
          textStyle: {
            color: "#fff"
          }
        },
        tooltip: {
          trigger: "axis"
        },
        grid: {
          left: "70",
          right: "5",
          bottom: "20",
          top: "20",
          containLabel: false
        },
        xAxis: {
          type: "value",
          show: false
        },
        yAxis: {
          type: "category",
          data: ydata,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            margin: 70,
            width: 80,
            align: "left",
            overflow: "truncate",
            formatter: function(value, index) {
              let ind = index + 1;
              if (ind == ydata.length) {
                return "{one|" + (ydata.length - index) + "} {a|" + value + "}";
              } else if (ind + 1 == ydata.length) {
                return "{two|" + (ydata.length - index) + "} {b|" + value + "}";
              } else if (ind + 2 == ydata.length) {
                return (
                  "{three|" + (ydata.length - index) + "} {c|" + value + "}"
                );
              }
              if (ydata.length - index > 9) {
                return (
                  "{five|" + (ydata.length - index) + "} {d|" + value + "}"
                );
              }
              return "{four|" + (ydata.length - index) + "} {d|" + value + "}";
            },
            rich: {
              a: {
                color: "#59c9f9"
              },
              b: {
                color: "#59c9f9"
              },
              c: {
                color: "#59c9f9"
              },
              d: {
                color: "#59c9f9"
              },
              // 第一名
              one: {
                backgroundColor: "#E86452",
                color: "white",
                width: 12,
                height: 16,
                padding: [1, 0, 0, 5],
                borderRadius: 10,
                fontSize: 11
              },
              // 第二名
              two: {
                backgroundColor: "#FF9845",
                color: "white",
                width: 12,
                height: 16,
                padding: [1, 0, 0, 5],
                borderRadius: 10,
                fontSize: 11
              },
              // 第三名
              three: {
                backgroundColor: "#F6BD16",
                color: "white",
                width: 12,
                height: 16,
                padding: [1, 0, 0, 5],
                borderRadius: 10,
                fontSize: 11
              },
              // 一位数
              four: {
                backgroundColor: "rgba(0,0,0,0.15)",
                color: "white",
                width: 12,
                height: 16,
                padding: [1, 0, 0, 5],
                borderRadius: 10,
                fontSize: 11
              },
              // 两位数
              five: {
                backgroundColor: "rgba(0,0,0,0.15)",
                color: "white",
                width: 16,
                height: 16,
                padding: [1, 0, 0, 1],
                borderRadius: 10,
                fontSize: 11
              }
            }
          }
        },
        series: [
          {
            type: "bar",
            showBackground: true,
            label: {
              show: true,
              position: "right",
              color: "#00d0ff"
            },
            barWidth: 20,
            itemStyle: {
              normal: {
                borderRadius: [3, 20, 20, 3],
                color: function(params) {
                  // 设置柱形图的颜色
                  if (params.dataIndex === 6) {
                    return "#d84430";
                  } else if (params.dataIndex === 5) {
                    return "#f38237";
                  } else if (params.dataIndex === 4) {
                    return "#e2aa20";
                  } else {
                    return "#5B8FF9";
                  }
                }
              }
            },
            data: xdata
          }
        ]
      };
      option && DataRanking.setOption(option);
      window.addEventListener("resize", function() {
        DataRanking.resize();
      });
    },

    // 获取设备信息
    async getDevice() {
      const { data: res } = await this.$axios.get(`${this.$api}/report/device`);
      this.device.total = res.data.total;
      this.device.offlineCount = res.data.offlineCount;
      this.device.onlineCount = res.data.onlineCount;
      this.getAlarm();
      this.getMediaDuration();
    },
    // 获取报警信息
    async getAlarm() {
      const { data: res } = await this.$axios.get(`${this.$api}/report/alarm`);
      this.alarmList = res.data;
    },
    // 根据拍摄时长排名前7为人员
    async getMediaDuration() {
      const { data: res } = await this.$axios.get(
        `${this.$api}/report/mediaDuration`
      );
      this.MediaDurationList = res.data;
      this.DataRanking();
    },
    // 获取全部单位树
    async GetAllDepTrees() {
      const { data: res } = await this.$axios.get(
        `${this.$api}/department/getDepTree`
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.depTrees = res.data;
    },
    handleNodeClick(data) {
      // EventBus.$emit('dId', data);
      window.sessionStorage.setItem(
        "depId1",
        window.JSON.stringify(data.depId)
      );
      // console.log(data);
      // var id = data.depId;
      // this.$router.push({ path: `/liveVideo` });
  
      this.$router.push({ path: `/main` });
      console.log("跳转");
    }
  }
};
</script>

<style lang="less" scoped>
/* 整个页面大的背景图片 */
.dataBoard-bgimg {
  overflow: hidden;
  width: 100%;
  height: 100%;
  // background-color: burlywood;
  background-image: url(../../../assets/img/dataBoard/bg.png);
  /*  背景图片平铺 */
  background-repeat: repeat;
  background-size: 100% 100%;
  z-index: -1;
  // position: relative;
  /* 背景图像固定 */
  /* background-attachment: fixed; */
}

//整个左边大的区域
.dataBoard-left-box {
  height: calc(100vh - 20px);
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: space-around;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: space-around;
  margin: 20px 0 0 0;
  position: absolute;
  top: 10px;
  left: 20px;
  width: 20%; /* 根据需要调整宽度 */
  height: calc(100vh - 40px); /* 根据需要调整高度 */
  z-index: 2; /* 设置较高的 z-index */
}
// 左边上面区域边框
.left-top-box {
  background-image: url(../../../assets/img/dataBoard/box4.png);
  width: 100%;
  height: 25%;

  /*  背景图片平铺 */
  background-repeat: repeat;
  background-size: 100% 100%;

  // 在线数字
  .num {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 80%;
    font-size: 2.5rem;
  }
  // 设备状态文字
  .txt {
    height: 5%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-size: 1.3rem;
  }
}
// 在线设备圆圈
.zx {
  background-image: url(../../../assets/img/dataBoard/zx.png);
  width: 25%;
  height: 80%;
  /*  背景图片平铺 */
  background-repeat: repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

// 在线设备文字颜色
.zx-txt {
  color: #00ffda;
}
// 离线设备圆圈
.lx {
  background-image: url(../../../assets/img/dataBoard/lx.png);
  width: 25%;
  height: 80%;
  /*  背景图片平铺 */
  background-repeat: repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
// 离线设备文字
.lx-txt {
  color: #dfe95f;
}
// 未绑定设备圆圈
.wzc {
  background-image: url(../../../assets/img/dataBoard/wzc.png);
  width: 25%;
  height: 80%;
  /*  背景图片平铺 */
  background-repeat: repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
// 未绑定设备文字
.wzc-txt {
  color: #ff6666;
}

// 左边中间边框
.left-center-box {
  background-image: url(../../../assets/img/dataBoard/box2.png);
  width: 100%;
  height: 40%;
  /*  背景图片平铺 */
  background-repeat: repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
// 左边中间echarts高宽
.UnitFileStatistics {
  height: 280px;
  width: 420px;
}
// 左边下面边框
.left-bottom-box {
  background-image: url(../../../assets/img/dataBoard/box4.png);
  width: 100%;
  height: 30%;
  /*  背景图片平铺 */
  background-repeat: repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

// 左边下边echarts高宽
.test {
  height: 200px;
  width: 420px;
}
// 中间区域
.dataBoard-center-box {
  position: absolute;
  top: 0px;
  left: 22%; /* 根据左边区域的宽度调整 */
  right: 22%; /* 根据右边区域的宽度调整 */
  height: 20px; /* 根据需要调整高度 */
  z-index: 2; /* 设置较高的 z-index */
}
// 中间区域边框
.center-box {
  background-image: url(../../../assets/img/dataBoard/box6.png);
  width: 100%;
  height: 100%;
  /*  背景图片平铺 */
  background-repeat: repeat;
  background-size: 100% 100%;
}
// 中间地图echarts高宽
.map-data {
  height: 780px;
  width: 860px;
}
// 右边区域
.dataBoard-right-box {
  height: calc(100vh - 20px);
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: space-around;
  margin: 20px 0 0 0;
  position: absolute;
  top: 10px;
  right: 20px;
  width: 23.5%; /* 根据需要调整宽度 */
  z-index: 2;
}
// 右边上边边框
.right-top-box {
  background-image: url(../../../assets/img/dataBoard/box1.png);
  width: 100%;
  height: 25%;
  /*  背景图片平铺 */
  background-repeat: repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.backround {
  height: 150px;
  width: 420px;
  border: none;
  margin:0 10px;
  // background-image: url("../../../assets/img/dataBoard/bg.png");
}
/deep/ .el-table,
/deep/ .el-table__expanded-cell {
  background-color: transparent;
}
/* 表格内背景颜色 */
/deep/ .el-table th,
/deep/ .el-table tr,
/deep/ .el-table td {
  background-color: transparent;
  color: rgb(231, 232, 235);
  border: none;
  //  background: #021b27;
}

.seamless-warp {
  height: 80%;
  overflow: hidden;
}
/deep/.el-table .cell {
  text-align: center;
}
/deep/.toptitle {
  width: 100%;
  display: flex;
  // background-color: #071e29;
  margin-bottom: 10px;
  // border: 2px solid gainsboro;
  background-color: rgba(57, 120, 150, 0.668);
  color: #30dee5;
}

// 修改高亮当前行颜色
/deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
  box-shadow: 0px 0px 30px #36b8bf inset;
  background-color: #0405078a;
}

.el-table::before {
  //去除底部白线
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0px;
}

// 去掉表格单元格边框
.customer-table th {
  border: none;
}
.customer-table td,
.customer-table th.is-leaf {
  border: none;
}
// 表格最外边框
.el-table--border,
.el-table--group {
  border: none;
}
// 头部边框
.customer-table thead tr th.is-leaf {
  border: 1px solid #ebeef5;
  border-right: none;
}
.customer-table thead tr th:nth-last-of-type(2) {
  border-right: 1px solid #ebeef5;
}
// 表格最外层边框-底部边框
.el-table--border::after,
.el-table--group::after {
  width: 0;
}
.customer-table::before {
  width: 0;
}
.customer-table .el-table__fixed-right::before,
.el-table__fixed::before {
  width: 0;
}
// 表格有滚动时表格头边框
.el-table--border th.gutter:last-of-type {
  border: 1px solid #ebeef5;
  border-left: none;
}
.item {
  width: 50%;
  // border-right: 2px solid gainsboro;
  text-align: center;
}

// 右边中间边框
.right-center-box {
  background-image: url(../../../assets/img/dataBoard/box2.png);
  width: 100%;
  height: 40%;
  /*  背景图片平铺 */
  background-repeat: repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
// 右边中间排行榜echarts高宽
.DataRanking {
  height: 280px;
  width: 420px;
  margin: 0 10px;
}
// 右边下面边框
.right-bottom-box {
  background-image: url(../../../assets/img/dataBoard/box4.png);
  width: 100%;
  height: 30%;
  /*  背景图片平铺 */
  background-repeat: repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  /*  背景图片平铺 */
  background-repeat: repeat;
  background-size: 100% 100%;
}
// 右边下面echarts高宽
.test1 {
  height: 200px;
  width: 420px;
}
.el-row {
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 20px);

  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}

/* 左边单位列表 */
.leftBox {
  width: 100%;
  min-width: 300px;
  height: calc(100vh - 15px);
  background-color: #063d6b;
  background-image: url(../../../assets/img/dataBoard/box2.png);
  /*  背景图片平铺 */
  background-repeat: repeat;
  background-size: 100% 100%;
  opacity: 0.8;
  /* position: absolute; */
  /* left: 0; */
  display: flex;
  // z-index: 999;
}

/* 组织架构信息列表区域 */
.treeBox {
  width: 100%;
  margin: 45px 10px 20px 10px;
  height: calc(100vh - 120px) !important;
  overflow-y: auto !important;
  overflow-x: auto !important;
}
.top-box {
  z-index: 2;
}

.bm-view {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1; /* 提升到上一层 */
}

/* 百度地图 */
.bmap-container {
  // display: flex;

  width: 100%;
  height: calc(100vh);
  color: #076961;
}
</style>



// WEBPACK FOOTER //
// src/components/Main/DataBoard/dataBoard.vue